/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface RegisterFCMRequest {
    'newToken': string;
    'oldToken'?: string;
    'os': RegisterFCMRequestOsEnum;
}

export const RegisterFCMRequestOsEnum = {
    Android: 'ANDROID',
    Ios: 'IOS',
    Web: 'WEB',
    Fuchsia: 'FUCHSIA',
    Linux: 'LINUX',
    Macos: 'MACOS',
    Windows: 'WINDOWS',
} as const;

export type RegisterFCMRequestOsEnum = typeof RegisterFCMRequestOsEnum[keyof typeof RegisterFCMRequestOsEnum];


